import { combineReducers } from "redux";
import country from "../features/admin/masters/country/Slice";
import state from "../features/admin/masters/state/Slice";
import city from "../features/admin/masters/city/Slice";
import pincode from "../features/admin/masters/pincode/Slice";
import area from "../features/admin/masters/area/Slice";

import whychooseus from "../features/admin/masters/whychooseus/Slice";

import termsandconditions from "../features/admin/masters/termsandconditions/Slice";
import blog_categories from "../features/admin/masters/blog_categories/Slice";
import blogs from "../features/admin/masters/blogs/Slice";
import about_us from "../features/admin/masters/about_us/slice";
import gender from "../features/admin/masters/gender/slice";
import appsetup from "../features/admin/masters/app_setup/slice";
import game_rule from "../features/admin/masters/game_rule/slice";
import faqs from "../features/admin/masters/faqs/Slice";
import sociallink from "../features/admin/masters/social_link/slice";

import game_offer from "../features/admin/masters/game_offer/slice";
import user_feedback from "../features/admin/masters/user_feedback/slice";

import homeBanners from "../features/admin/masters/home_banner/slice";
import announcement from "../features/admin/masters/announcement/slice";
import turnover from "../features/admin/masters/turnover/slice";
import levels from "../features/admin/masters/level/slice";

import turntable_spin from "../features/admin/masters/turntable_spin/slice";

import gift_codes from "../features/admin/masters/gift_code/Slice";
import payment_qr from "../features/admin/masters/payment_qr/slice";
import crypto_wallet from "../features/admin/masters/crypto_wallet/slice";

const masters = combineReducers({
  country: country,
  state: state,
  city: city,
  pincode: pincode,
  area: area,
  whychooseus: whychooseus,
  termsandconditions: termsandconditions,
  blog_categories: blog_categories,
  blogs: blogs,
  homeBanners: homeBanners,
  about_us: about_us,
  gender: gender,
  appsetup: appsetup,
  sociallink: sociallink,
  game_offer: game_offer,
  user_feedback: user_feedback,
  announcement: announcement,
  game_rule: game_rule,
  faqs: faqs,
  turnover: turnover,
  levels: levels,

  turntable_spin: turntable_spin,

  gift_codes: gift_codes,
  payment_qr: payment_qr,
  crypto_wallet: crypto_wallet,
});

export default masters;
